import React from 'react';
import { Routes, Route, Link, useSearchParams } from 'react-router-dom';
import ProjectManagerAdvanced from './ProjectManagerAdvanced';
import ProjectManagerBasic from './ProjectManagerBasic';

const VersionSwitcherProject: React.FC<{ currentVersion: string }> = ({ currentVersion }) => {
  return (
    <div className="version-switcher-project" style={{
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      padding: '20px',
      margin: '20px',
      borderRadius: '15px',
      textAlign: 'center',
      border: '1px solid rgba(255, 255, 255, 0.2)'
    }}>
      <h3 style={{ color: 'white', marginBottom: '20px', fontSize: '1.2rem' }}>Compare Versions:</h3>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
        <Link 
          to="?version=1.0" 
          style={{
            padding: '12px 24px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            background: currentVersion === '1.0' ? 'rgba(255, 107, 107, 0.8)' : 'rgba(255, 107, 107, 0.6)',
            color: 'white',
            borderColor: '#ff6b6b',
            transform: currentVersion === '1.0' ? 'scale(1.05)' : 'scale(1)',
            boxShadow: currentVersion === '1.0' ? '0 5px 15px rgba(0, 0, 0, 0.3)' : 'none'
          }}
        >
          Synoppy 1.0 - Basic
        </Link>
        <Link 
          to="?version=1.5" 
          style={{
            padding: '12px 24px',
            borderRadius: '25px',
            textDecoration: 'none',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            border: '2px solid transparent',
            background: currentVersion === '1.5' ? 'rgba(253, 121, 168, 0.8)' : 'rgba(253, 121, 168, 0.6)',
            color: 'white',
            borderColor: '#fd79a8',
            transform: currentVersion === '1.5' ? 'scale(1.05)' : 'scale(1)',
            boxShadow: currentVersion === '1.5' ? '0 5px 15px rgba(0, 0, 0, 0.3)' : 'none'
          }}
        >
          Synoppy 1.5 - Advanced
        </Link>
      </div>
    </div>
  );
};

const ProjectAbout: React.FC = () => {
  return (
    <div style={{ padding: '20px', background: 'linear-gradient(135deg, #fd79a8, #e84393)', minHeight: '100vh', color: 'white' }}>
      <Link to="/project-manager" style={{ color: 'white' }}>← Back to Project Manager</Link>
      <h1>About Project Management Suite</h1>
      <div style={{ background: 'rgba(0,0,0,0.2)', padding: '20px', borderRadius: '10px', margin: '20px 0' }}>
        <h2>Prompt</h2>
        <p>"Create a project management application"</p>
      </div>
      <Link to="/" style={{ color: 'white' }}>Home</Link>
    </div>
  );
};

const ProjectManager: React.FC = () => {
  const [searchParams] = useSearchParams();
  const version = searchParams.get('version') || '1.5';
  
  if (version === '1.0') {
    return (
      <div style={{ background: 'linear-gradient(135deg, #fd79a8, #e84393)', minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={
            <div>
              <VersionSwitcherProject currentVersion="1.0" />
              <ProjectManagerBasic />
            </div>
          } />
          <Route path="/about" element={<ProjectAbout />} />
        </Routes>
      </div>
    );
  }
  
  return (
    <Routes>
      <Route path="/" element={
        <div>
          <VersionSwitcherProject currentVersion="1.5" />
          <ProjectManagerAdvanced />
        </div>
      } />
      <Route path="/about" element={<ProjectAbout />} />
    </Routes>
  );
};

export default ProjectManager;